import React, { useState, useEffect, useRef } from 'react';
import { useModal } from './ModalContext'; // Ensure you import the useModal hook
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../styles/Header.scss';

import { useLocation, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
    const Logo = `${process.env.REACT_APP_S3_URL}mobilewarelogo.svg`;
    const MenuIcon = `${process.env.REACT_APP_S3_URL}MenuIcon.svg`;
    const DropdownIcon = `${process.env.REACT_APP_S3_URL}DropdownArrow.svg`;
    const UpiIcon = `${process.env.REACT_APP_S3_URL}productsHeader/Scanner.svg`;
    const ImpsIcon = `${process.env.REACT_APP_S3_URL}productsHeader/BankIcon.svg`;
    const BbpsIcon = `${process.env.REACT_APP_S3_URL}productsHeader/bbps_icon.svg`;
    const AepsIcon = `${process.env.REACT_APP_S3_URL}productsHeader/aeps.svg`;
    const Close = `${process.env.REACT_APP_S3_URL}close.svg`;

    const navigate = useNavigate();
    const location = useLocation();
    console.log('location', location);
    const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    const [openMobileNavbar, setOpenMobileNavbar] = useState(false);
    const productsDropdownRef = useRef<HTMLLIElement>(null);
    const companyDropdownRef = useRef<HTMLLIElement>(null);
    const productDropdownOptions = [
        {
            name: 'UPI',
            description: 'Fast, Secure Digital Payments',
            imageUrl: UpiIcon,
            link: '/products/upi'
        },
        {
            name: 'IMPS',
            description: 'Instant, 24/7 Bank Transfers',
            imageUrl: ImpsIcon,
            link: '/products/imps'
        },
        {
            name: 'BBPS',
            description: 'Seamless Bill Payments Online ',
            imageUrl: BbpsIcon,
            link: '/products/bbps'
        },
        {
            name: 'AePS',
            description: 'Biometric Banking & Cash Access',
            imageUrl: AepsIcon,
            link: '/products/aeps'
        }
    ]

    const companyDropdownOptions = [
        {
            name: 'Careers',
            description: 'Join Our Growing Team and Build Your Future',
            imageUrl: UpiIcon,
            link: '/Careers'
        },
        {
            name: 'Resources',
            description: 'Explore Insights, Guides, Case Studies, News, and More',
            imageUrl: ImpsIcon,
            link: '/Resources/Blogs'
        },
        {
            name: 'About Us',
            description: 'Discover Our Story, Vision, and What Drives Us',
            imageUrl: BbpsIcon,
            link: '/AboutUs'
        }
    ]
    const { openModal } = useModal(); 

    const toggleProductsDropdown = (open: boolean) => {
        setIsProductsDropdownOpen(open);
    };

    const toggleCompanyDropdown = (open: boolean) => {
        setIsCompanyDropdownOpen(open);
    };
    useEffect(() => {
        const closeDropdown = (e: MouseEvent) => {
            if (productsDropdownRef.current && !productsDropdownRef.current.contains(e.target as Node)) {
                setIsProductsDropdownOpen(false);
            }
            if (companyDropdownRef.current && !companyDropdownRef.current.contains(e.target as Node)) {
                setIsCompanyDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', closeDropdown);
        return () => {
            document.removeEventListener('mousedown', closeDropdown);
        };
    }, []);

    
    return (
        <div className={`header 
            ${ !openMobileNavbar ? 'top-position' : ''}
        `}>
            <div onClick = {() => navigate('/')} style={{ cursor: 'pointer' }}>
                <img style={{ height: 48}} src={Logo} alt="MobileWare Logo" />
            </div>
            <nav className="nav" style={ isProductsDropdownOpen || isCompanyDropdownOpen ? {
                position: 'relative'
            } : {}}
            
                        onMouseLeave={() => {
                            toggleProductsDropdown(false);
                            toggleCompanyDropdown(false);
                            }
                        }
                        >
                <ul>
                    <li><a style={{ color : (location.pathname === '/') ? '#E5194B': '#575656'}} href="/" 
                        onMouseEnter={() => {
                            toggleProductsDropdown(false);
                            toggleCompanyDropdown(false)}
                        }
                        >Home</a></li>
                    <li className="dropdown product"
                        onMouseEnter={() =>  {
                            toggleProductsDropdown(true);
                            toggleCompanyDropdown(false);
                        }
                        }
                        >
                        <a style={{ color : (location.pathname === '/products/upi'
                            || location.pathname === '/products/imps' || location.pathname === '/products/aeps' || location.pathname === '/products/bbps'
                        ) ? '#E5194B': '#575656'}}  className="dropdown-link">Products 
                            <img style={{ width: 16, height:16 }} src={DropdownIcon} />
                        </a>
                        {isProductsDropdownOpen && (
                            <div className="product-sub-dropdown"        
                                // onMouseEnter={() => toggleProductsDropdown(true)}
                                // onMouseLeave={() => toggleProductsDropdown(false)}
                            >
                                   {productDropdownOptions.map(item => (
                                    <a href={item.link} className="product-dropdown-item" key={item.link}>
                                        <img src={item.imageUrl} alt={item.name} width="16"/>
                                        <div className="product-dropdown-name">{item.name}</div>
                                        <div className="product-dropdown-description">{item.description}</div>
                                    </a>
                                   ))}
                            </div>
                        )}
                    </li>
                    <li><a style={{ color : (location.pathname === '/TransXT') ? '#E5194B': ''}} href="/TransXT"
                    onMouseEnter={() => toggleProductsDropdown(false)}>TransXT</a></li>
                    <li className="dropdown product"
                        onMouseEnter={() => {
                            toggleProductsDropdown(false);
                            toggleCompanyDropdown(true)}}
                        >
                        <a style={{ color : (location.pathname === '/Careers' || location.pathname === '/Resources/Blogs' || location.pathname === '/AboutUs') ? '#E5194B': '#575656'}}  className="dropdown-link">Company<img style={{ width: 16, height:16 }} src={DropdownIcon} /></a>
                        {isCompanyDropdownOpen && (
                            <div className="product-sub-dropdown"        
                                // onMouseEnter={() => toggleProductsDropdown(true)}
                                // onMouseLeave={() => toggleProductsDropdown(false)}
                            >
                                   {companyDropdownOptions.map(item => (
                                    <a href={item.link} className="product-dropdown-item" key={item.link}>
                                        <img src={item.imageUrl} alt={item.name} width="16"/>
                                        <div className="product-dropdown-name">{item.name}</div>
                                        <div className="product-dropdown-description">{item.description}</div>
                                    </a>
                                   ))}
                            </div>
                        )}
                    </li>
                </ul>
            </nav>
            <button className="contactButton" onClick={openModal}>Contact</button>
            <button className='menu' onClick={() => setOpenMobileNavbar(true)}>
                <img className='menuIcon' src={MenuIcon} alt='' />
            </button>
            { openMobileNavbar && (
                <div className='nav-mobile'>
                    <div className="nav-header-mobile">
                        <img style={{ height: 48, cursor: 'pointer' }}  src={Logo} alt="logo" onClick = {() => navigate('/')}/>
                        <img src={Close} alt="logo" onClick={() => setOpenMobileNavbar(false)}/>
                    </div>
                    <a href="/" className="route-mobile">Home</a>
                    <Accordion
                        expanded={isProductsDropdownOpen}
                        onChange={() => {
                            toggleProductsDropdown(!isProductsDropdownOpen);
                            toggleCompanyDropdown(false);
                        }}  
                        // sx={{
                        //     '&.Mui-expanded': {
                        //     background: 'linear-gradient(to bottom, #fdf4f6 50%, #FFFFFF 50%)',
                        //     }
                        // }}
                        >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"    
                            id="panel1-header"
                            sx={{
                                '& .MuiAccordionSummary-expandIconWrapper': {
                                    color: '#ee6586',
                                }
                            }}
                        >
                        <div className="accordion-title">Products</div>
                        </AccordionSummary>
                        <AccordionDetails>
                        <div className="accordion-details">
                            {productDropdownOptions.map(item => (
                                    <a href={item.link} className="product-dropdown-item" key={item.link}>
                                        <img src={item.imageUrl} alt={item.name} width="16"/>
                                        <div className="product-dropdown-name">{item.name}</div>
                                        <div className="product-dropdown-description">{item.description}</div>
                                    </a>
                            ))}
                        </div>
                        </AccordionDetails>
                    </Accordion>
                    <a href="/TransXT" className="route-mobile">TransXT</a>
                    <Accordion  
                        expanded={isCompanyDropdownOpen}
                        onChange={() => { 
                            toggleCompanyDropdown(!isCompanyDropdownOpen);
                            toggleProductsDropdown(false);
                         }}
                        // sx={{
                        //     '&.Mui-expanded': {
                        //     background: 'linear-gradient(to bottom, #fdf4f6 50%, #FFFFFF 50%)',
                        //     }
                        // }}
                        >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"    
                            id="panel1-header"
                            sx={{
                                '& .MuiAccordionSummary-expandIconWrapper': {
                                    color: '#ee6586',
                                }
                            }}
                        >
                        <div className="accordion-title">Company</div>
                        </AccordionSummary>
                        <AccordionDetails>
                        <div className="accordion-details">
                            {companyDropdownOptions.map(item => (
                                    <a href={item.link} className="product-dropdown-item" key={item.link}>
                                        <img src={item.imageUrl} alt={item.name} width="16"/>
                                        <div className="product-dropdown-name">{item.name}</div>
                                        <div className="product-dropdown-description">{item.description}</div>
                                    </a>
                            ))}
                        </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
            )}
        </div>
    );
};
export default Header;
